app.controller("SubjectConfessionController", ["$scope", "$uibModalInstance", "ProgramService", "Subject", "Lecturer", "Selection", "student",
    function ($scope, $uibModalInstance, ProgramService, Subject, Lecturer, Selection, student) {
        $scope.name = "";
        $scope.chosenProgram = null;
        $scope.passed = true;
        $scope.selectionState = 'proved';
        loadProgram();

        function loadProgram() {
            if (student.program) {
                ProgramService.fetchOne(student.program._id).then(function (data) {
                    $scope.chosenProgram = data;
                    // +4 allows selections beyond the program length
                    $scope.semesters = _.range(1, data.semesters + 5);
                })
            }
        }

        $scope.getLecturers = function (name) {
            return Lecturer.list({
                query: name
            }).then(function (data) {
                return data.docs
            });
        };

        function resultGen(val) {
            val = $scope.score;
            $scope.result = 'F';
            if (!$scope.passed) {
                return;
            }

            if (val > 90) $scope.result = 'A';
            else if (val > 80) $scope.result = 'B';
            else if (val > 70) $scope.result = 'C';
            else if (val > 60) $scope.result = 'D';
            else if (val > 50) $scope.result = 'E';
        }

        $scope.$watch('score', resultGen);

        $scope.$watch('passed', resultGen);

        $scope.getSubjectWrappers = function (name) {
            return Subject.wrappersList({
                query: name,
                program: $scope.chosenProgram._id
            }).then(function (data) {
                return data.docs
            });
        };

        $scope.saveSubjectConfession = function () {
            Selection.saveSubjectConfession({
                profile: student._id,
                score: $scope.score,
                name: $scope.name,
                subject: ($scope.chosenSubject && $scope.chosenSubject.subject) ? $scope.chosenSubject.subject._id : null,
                reason: $scope.reason,
                semester: $scope.semester,
                selectionState: $scope.selectionState,
                state: $scope.passed ? 'passed' : 'failed',
                credits: $scope.credits,
                result: $scope.result,
                confessed: $scope.confessed,
                subjectWrapper: $scope.chosenSubject ? $scope.chosenSubject._id : undefined
            }).then(function () {
                $uibModalInstance.dismiss();
            })
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
